import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const baseUrl = "https://ecart.mgmebuild.com/api/";

function EditProfile() {

  const user_id = localStorage.getItem("user_id");

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone_number: "",
    address: "",
    pincode: "",
    latitude: "",
    longitude: "",

    password: ""
  });

  // -----------------------
  // LOAD PROFILE
  // -----------------------
  const loadProfile = async () => {

    if (!user_id) {
      Swal.fire("Error", "Login Required", "error");
      return;
    }

    try {
      const res = await axios.get(
        `${baseUrl}profile/?user_id=${user_id}`
      );

      setFormData(res.data);

    } catch {
      Swal.fire("Error", "Failed to load profile", "error");
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  // -----------------------
  // HANDLE CHANGE
  // -----------------------
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // -----------------------
  // UPDATE PROFILE
  // -----------------------
  const submitForm = async () => {

    try {
      await axios.put(
        `${baseUrl}profile/update/`,
        {
          ...formData,
          user_id: user_id
        }
      );

      Swal.fire("Success", "Profile Updated", "success");

      localStorage.setItem("username", formData.username);
        window.location.href = "/";

    } catch {
      Swal.fire("Error", "Update Failed", "error");
    }
  };
const getLocation = () => {

    if (!navigator.geolocation) {
      Swal.fire("Error", "GPS not supported", "error");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {

        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        try {
          const res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
          );

          setFormData({
            ...formData,
            latitude: lat,
            longitude: lon,
            address: res.data.display_name
          });

          Swal.fire("Success", "Address fetched successfully", "success");

        } catch {
          Swal.fire("Error", "Failed to fetch address", "error");
        }
      },
      () => Swal.fire("Error", "Location permission denied", "error")
    );
  };

  return (
    <section className="container mt-4">

      <h3
        className="text-center"
        style={{ background: "#198754", color: "white" }}
      >
        Edit Profile
      </h3>

      <table className="erp-table-modern mt-4">
        <tbody>

          <tr>
            <td>Username</td>
            <td>
              <input
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </td>
          </tr>

          <tr>
            <td>Email</td>
            <td>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </td>
          </tr>

          <tr>
            <td>Mobile</td>
            <td>
              <input
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
              />
            </td>
          </tr>

          <tr>
            <td>Address</td>
            <td>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
                                <button
                    type="button"
                    className="btn btn-info ms-2"
                    onClick={getLocation}
                  >
                    <i className="fa-solid fa-location-dot"></i>
                  </button>

            </td>
          </tr>
              <tr>
                <td>Pincode</td>
                <td>
                  <input
                    type="number"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                  />
                </td>
              </tr>

          <tr>
            <td>New Password</td>
            <td>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Leave empty to keep same"
              />
            </td>
          </tr>

          <tr>
            <td colSpan="2" className="text-center">
              <button
                className="btn btn-success"
                onClick={submitForm}
              >
                Update Profile
              </button>
            </td>
          </tr>

        </tbody>
      </table>

    </section>
  );
}

export default EditProfile;
